import React, {useState} from 'react';
import { Notes } from '../Notes/Notes';
import { Button } from '../../react/utils/button/Button';
import { Checkbox } from '../../react/utils/checkbox/Checkbox';
import { v4 as uuidv4 } from 'uuid';

type NoteHistory = {
  id: string,
  userId: string,
  userFullName: string,
  createdAt: Date
}

type AutomationTechnology = {
  id: string,
  automationName: string
}

type ProcessNotesProps = {
  text: string,
  saveNote: (text: string, automation: string[]) => void,
  noteHistory?: NoteHistory[],
  automation?: string[],
  automationTechnologies?: AutomationTechnology[],
  clientNotes?: boolean,
  clientNotesHeader?: string
}

export const ProcessNotes = ({text, saveNote, noteHistory, automation = [], automationTechnologies, clientNotes, clientNotesHeader}: ProcessNotesProps) => {
  const [note, setNote] = useState(text);
  const [isNoteHistoryVisible, setNoteHistoryVisible] = useState(false);
  const [automationOptions, setAutomationOptions] = useState(automation);
  const onChangeHandler = (key) => {
    if (automationOptions.includes(key))
      setAutomationOptions(automationOptions.filter(optionKey => optionKey !== key));
    else
      setAutomationOptions([...automationOptions, key]);
  };

  return (
    <section className="pProcessNotes__notes">
      <section className="pProcessNotes__notesHeader">
        {!clientNotes && automationTechnologies.length > 0 &&
          <div className="pProcessNotes__notesHeaderContent">
            <h3>Automation implemented:</h3>
            <div>
              {automationTechnologies.map(technology =>
                <Checkbox
                  key={uuidv4()}
                  label={technology.automationName}
                  onChange={() => onChangeHandler(technology.id)}
                  value={automationOptions.includes(technology.id)}
                />
              )}
            </div>
          </div>
        }
        {clientNotes && clientNotesHeader && 
          <div className="pProcessNotes__notesHeaderContent">
            <h3>{clientNotesHeader}</h3>
          </div>
        }
        {Boolean(noteHistory?.length) &&
          <Button
            text={`${isNoteHistoryVisible ? 'Hide' : 'Show'} history`}
            onClick={() => setNoteHistoryVisible(prev => !prev)}
          ></Button>
        }
      </section>
      <section className="pProcessNotes__notesBox">
        <Notes text={note} onChange={setNote} classname="pProcessNotes__notes" />
        {isNoteHistoryVisible &&
          <ul className="pProcessNotes__notesHistory">
            {noteHistory.map(history => (
              <li key={uuidv4()}>
                <div className="pProcessNotes__notesHistoryDate">{history.createdAt}</div>
                <div className="pProcessNotes__notesHistoryName">{history.userFullName}</div>
              </li>
            ))}
          </ul>
        }
      </section>
      <section className="pProcessNotes__notesFooter">
        <Button text="Save" onClick={() => saveNote(note, automationOptions)} type="save" />
      </section>
    </section>
  );
};
